import { useRef } from 'react'
import styled from 'styled-components'
import { useDetectOutsideClick } from '../../../../../../generic/hooks/useDetectOutsideClick'
import ArizotSenderItem from './arizotSenderItem'

const Wrapper = styled.div`
    background: #fff;
    position: absolute;
    width: 100%;
    bottom: -7em;
    height: 7em;
    overflow-y: auto;
    /* display: flex; */
    flex-flow: column;
    border-radius:30px;
    padding: 0 1em;
    transform: translateY(-0.2em);
    border-top: 1px solid rgba(0,0,0,0.2);
    z-index: 3;
    -webkit-box-shadow: -2px 8px 2px -6px rgba(41,127,118,0.31); 
    box-shadow: -2px 8px 2px -6px rgba(41,127,118,0.31);
    &::-webkit-scrollbar {
        width: 0;
    }

`


export default function ArizotSenderList({sender, setWrapperSenderStatus, setInputSender, wrapperSenderStatus, setClientIdSender}){
    const ref = useRef(null)
    useDetectOutsideClick(ref, () => {setWrapperSenderStatus(false)})
    let statusToggle = wrapperSenderStatus ? 'flex' : 'none'
    return(
        <Wrapper ref={ref} style={{display: statusToggle}}>
            {sender.map(item => 
                <ArizotSenderItem 
                    key={item.ClientID} 
                    {...item} 
                    setInputSender={setInputSender} 
                    setWrapperSenderStatus={setWrapperSenderStatus} 
                    setClientIdSender={setClientIdSender}
                />
            )}
        </Wrapper>
    )
}